import React from 'react';
import { useParams } from 'react-router-dom';

import { URL } from '../../../../constants';
import { getUrl } from '../../../../utils';

import { getShareText } from '../../components/getText';
import VBAccordion from './vbAccordion';
import VBBtn from './vbBtn';

interface Props {
  peopleCount: number;
}

const ShareStep: React.FC<Props> = (props) => {
  const { eventId = '' } = useParams();

  const { peopleCount } = props;

  const { shareText } = getShareText(peopleCount);

  return (
    <VBAccordion
      heading="Share"
      subheading={shareText}
      isOpen
      isDisabled={peopleCount === 0}
    >
      <VBBtn
        type="share"
        heading="Share"
        subheading="Share via email or copy share link"
        link={getUrl(URL.VB_SHARE, eventId)}
      />
    </VBAccordion>
  );
};

export default ShareStep;
